import { render, staticRenderFns } from "./TrashScansPage.vue?vue&type=template&id=37fd35c2"
import script from "./TrashScansPage.vue?vue&type=script&lang=js"
export * from "./TrashScansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports